import { render, staticRenderFns } from "./WarrantNote.vue?vue&type=template&id=48732120&scoped=true"
import script from "./WarrantNote.vue?vue&type=script&lang=js"
export * from "./WarrantNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48732120",
  null
  
)

export default component.exports